import {Utils} from "../../Utils";

declare var Highcharts: any;
import { Component, OnInit, OnDestroy } from '@angular/core';
import {DashboardService} from "../../../dashboard/services/dashboard.service";
import { DatePipe} from "@angular/common";

@Component({
  selector: 'app-nuclear-outages',
  templateUrl: './nuclear-outages.component.html'
})
export class NuclearOutagesComponent implements OnInit, OnDestroy {

  data: any;
  _chartOptions: any;
  displayChart: boolean = false;
  subscription: any;
  currentDateIndex: number = -1;
  currentDay: number = 0;
  constructor(private dashboardService: DashboardService, public datePipe: DatePipe) { }

  ngOnInit() {
    let that = this;
    this._chartOptions = {
        chart:{
            logo: Highcharts.logos.none,
          height: 350
        },
      title: {
        text: 'Daily U.S. nuclear outages'
      },
      xAxis : {
        type : 'datetime',
        plotLines: [{
          color : Highcharts.eia_red,
          width : 2,
          value : null,
          label : {
            text : null,
            rotation : 0,
            y : 20,
            x : null,
            align : null
          }
        }],
        showLastLabel : false,
        endOnTick : false
      },
      yAxis : {
        title: {
          text : 'gigawatts (GW)'
        }
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom'
      },
      tooltip: {
        shared: true,
          formatter: function(){
              var formatter = this;

              function checkForData(){
                  var toolTipString = '';
                  var theDate = that.datePipe.transform(new Date(formatter.x),'MMMM dd', 'UTC'); //Utils.dateAsMMMDD(new Date(formatter.x));

                  toolTipString += '<div>' + theDate + '</div><br>';

                  formatter.points.forEach(function(element){
                      if(element.series.name.toUpperCase().indexOf('RANGE')>-1){
                          toolTipString += '<div><b>' + element.series.name.toLowerCase() +': </b>'+ element.point.low +  ' to ' + element.point.high + '</div>';
                      }
                      else{
                          toolTipString += '<div><b>'+element.series.name.toLowerCase()+': </b>' + element.point.y + '</div><br>'

                      }
                  });
                  return toolTipString;
              }
              return checkForData();
          }
      },
      series: [{
          type: 'line',
          color : Utils.areaPlotColors.current,
          name : null,
          zIndex : 3
        }, {
          type: 'line',
          color : Utils.areaPlotColors.previous,
          name : null,
          zIndex : 2
        }, {
          type: 'arearange',
          color : Utils.areaPlotColors.range,
          lineWidth: 0,
          //fillOpacity: 0.3,
          name : null,
          zIndex : 1
        }
      ],
      credits : {
          enabled : false
      }
    };

    this.subscription = this.dashboardService.getNuclearOutages().subscribe(
      json => {
        this.data = json;
      }, null, () =>{
        for(let j = 0; j < this.data.length; j++) {
          this._chartOptions.series[j]['data'] = this.data[j]['data'].sort(function(a,b) {
            return (a[0] < b[0]) ? -1 : ((a[0] > b[0]) ? 1 : 0);
          });
        }
            //check through all of these data.
            // if the date is null check if the previous date is null.
            // If it isnt and that index is higher that the last one then

            for(let i = 0; i<that._chartOptions.series[0].data.length; i++){

                //null check
                if(that._chartOptions.series[0].data[i][1] == null){

                    //check if previous item is null keep going.
                    if (that._chartOptions.series[0].data[i-1][1] == null){
                        continue;
                    }

                    //since previous item is null, check if its id is higher than the last one that met this criteria
                    if(i > that.currentDateIndex){
                        that.currentDateIndex = i-1;
                        that.currentDay = that._chartOptions.series[0].data[i-1][0];
                    }
                }
            }

            //if nothing fits this criteria, the last item in the array is the current date so set that as the index.
            if(that.currentDateIndex == -1){that.currentDateIndex = this.data[0].data.length - 1;}

            //set custom marker for the current date Item
            let tempCurrentDate = Object.assign([],that._chartOptions.series[0].data[that.currentDateIndex]);
            that._chartOptions.series[0].data[that.currentDateIndex] = {
                x: tempCurrentDate[0],
                y: tempCurrentDate[1],
                marker:{
                    enabled: true,
                    symbol:'circle',
                    radius: 4
                }
            };



        // let current_day = null;
        // for(let i = 0; i < this._chartOptions.series[0].data.length; i++) {
        //   if(this._chartOptions.series[0].data[i][1] != null) {
        //     current_day = this._chartOptions.series[0].data[i][0];
        //   }
        //   else {
        //     break;
        //   }
        // }
        // this._chartOptions.xAxis.plotLines[0].value = current_day;
        let current_date = new Date(that.currentDay);
        let current_year = current_date.getUTCFullYear();
        // this._chartOptions.xAxis.plotLines[0].label.text = current_date.getMonth()+1 + '/' + current_date.getDate() + '/' + current_date.getFullYear();
        // this._chartOptions.xAxis.plotLines[0].label.x = current_date.getMonth() >= 6 ? -10 : 10;
        // this._chartOptions.xAxis.plotLines[0].label.align = current_date.getMonth() >= 6 ? 'right' : 'left';
        this._chartOptions.series[0].name = current_year.toString();
        this._chartOptions.series[1].name = (current_year - 1).toString();
        this._chartOptions.series[2].name = (current_year - 5).toString() + '-' + (current_year - 1).toString() + ' range';

        this.displayChart = true;
      }
    );
  }
  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/nuclear-outages/nuclear-outages.component.ts